// Wire types for spec/13.16 — `/api/v1/search`.
//
// Spec literal: `{ results: { type, id, primary, secondary, meta, link }[], total }`.
// We keep the extra `page/limit/totalPages` envelope the server returns
// so the page-level navigation can use it without a separate count call.

export type SearchKind = 'dm' | 'icn' | 'pm' | 'user';

export const ALL_SEARCH_KINDS: readonly SearchKind[] = [
  'dm',
  'icn',
  'pm',
  'user',
] as const;

export const SEARCH_KIND_LABEL: Record<SearchKind, string> = {
  dm: 'Data module',
  icn: 'Graphic (ICN)',
  pm: 'Publication module',
  user: 'User',
};

export interface SearchResult {
  type: SearchKind;
  id: string;
  primary: string;
  secondary: string;
  meta: string;
  link: string;
}

export interface SearchPage {
  results: SearchResult[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}
